import { AbstractControl, ValidatorFn } from '@angular/forms';
const EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9]))+$/i;
const MULTIPLE_EMAIL_REGEXP = /^(\s?[^\s,]+@[^\s,]+\.[^\s,]+\s?,)*(\s?[^\s,]+@[^\s,]+\.[^\s,]+)$/i;
const TELEPHONE_REGEXP = /^[0-9+ \-\(\)]{1,20}$/i;
// const MOBILE_REGEXP = /(^\+[0-9]{11,12}|^\+94)$/i;
const AREACODE_REGEXP = /([0-9]{3})$/i;
const MOBILE_REGEXP = /([0-9]{6})$/i;
const UNDERSCORESONLY_REGEXP = /\w$/i;
const URL_REGEXP =
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i;
const OMIT_SPECIALCHARACTORS_REGEXP = /^[^<>'\";`%@#$!&^*()?,~+._//=-]*$/i;
const NAME_ONLY_WITH_DOTS_REGEXP = /^[^<>'\";`%@#$!&^*()?,~+_//=-]*$/i;
const NIC_REGEXP = /(^[0-9]\d{11})|(^(\d{9}[x|X|v|V]))$/i;
const NIC_REGEXP_BN = /(^[0-9]\d{12})|(^(\d{10}))$/i;
const PASSPORT_REGEXP = /[a-z0-9]{4,}$/i; // ^[A-PR-WY][1-9]\d\s?\d{4}[1-9]$
const STOCKCODE_REGEXP = /[a-zA-Z]{1,4}.[a-zA-Z]{1}[0]{4}$/i;
const DIGITSONLY_REGEXP = /(^[0-9]+$)/i;
const CURRENCY_REGEXP =
  /^\$?(((\d{1,6}(\.\d{1,2})?)|(\d{1,3},\d{3}(\.\d{1,2})?)|\(((\d{1,6}(\.\d{1,2})?)|(\d{1,3},\d{3}(\.\d{1,2})?))\)))$/i;

export class GlobalValidators {
  static email: ValidatorFn = (control: AbstractControl) => {
    const value = control.value && control.value.trim();
    if (!!value && (value.length <= 5 || !EMAIL_REGEXP.test(value))) {
      return { email: true };
    }
    return null;
  };
  static multipleEmail: ValidatorFn = (control: AbstractControl) => {
    const value = control.value && control.value.trim();
    if (!!value && (value.length <= 5 || !MULTIPLE_EMAIL_REGEXP.test(value))) {
      return { multipleEmail: true };
    }
    return null;
  };
  static telephoneNo: ValidatorFn = (control: AbstractControl) => {
    const value = control.value && control.value.trim();
    if (!!value && (value.length <= 5 || !TELEPHONE_REGEXP.test(value))) {
      return { telephoneNo: true };
    }
    return null;
  };
  static mobileNo: ValidatorFn = (control: AbstractControl) => {
    const value = control.value && control.value.trim();
    if (!!value && !MOBILE_REGEXP.test(value)) {
      return { mobileNo: true };
    }
    return null;
  };
  static url: ValidatorFn = (control: AbstractControl) => {
    const value = control.value && control.value.trim();
    if (!!value && (value.length <= 5 || !URL_REGEXP.test(value))) {
      return { url: true };
    }
    return null;
  };
  static noop: ValidatorFn = (control: AbstractControl) => {
    return null;
  };
  static underscoreOnly: ValidatorFn = (control: AbstractControl) => {
    const value = control.value && control.value.trim();
    if (!!value && !UNDERSCORESONLY_REGEXP.test(value)) {
      return { underscoreOnly: true };
    }
    return null;
  };
  static password({ min = 8, uppercase = true, lowercase = true, number = true, specialChar = true } = {}) {
    return (control: AbstractControl) => {
      const value = control.value;
      if (!value) {
        return null;
      }
      return passwordValidate({ min, uppercase, lowercase, number, specialChar }, value);
    };
    function passwordValidate(passwordRequirements, passwordText: string) {
      passwordText = passwordText || '';
      // returns null if valid
      const validationResult = { min: true, uppercase: true, lowercase: true, number: true, specialChar: true };
      if ((passwordRequirements.min > 0 && !passwordText) || passwordText.length < passwordRequirements.min) {
        validationResult.min = false;
      }
      if (passwordRequirements.uppercase && /[A-Z]+/.exec(passwordText) === null) {
        validationResult.uppercase = false;
      }
      if (passwordRequirements.uppercase && /[a-z]+/.exec(passwordText) === null) {
        validationResult.lowercase = false;
      }
      if (passwordRequirements.number && /[0-9]+/.exec(passwordText) === null) {
        validationResult.number = false;
      }
      if (passwordRequirements.specialChar && /[^a-zA-Z0-9\s]+/.exec(passwordText) === null) {
        validationResult.specialChar = false;
      }
      if (
        validationResult.min &&
        validationResult.uppercase &&
        validationResult.lowercase &&
        validationResult.number &&
        validationResult.specialChar
      ) {
        return null;
      }
      const result = [];
      if (!validationResult.min) {
        result.push(` ${passwordRequirements.min - passwordText.length} more characters`);
      }
      if (!validationResult.uppercase) {
        result.push(` at least 1 Uppercase`);
      }
      if (!validationResult.lowercase) {
        result.push(` at least 1 Lowercase`);
      }
      if (!validationResult.number) {
        result.push(` at least 1 Number`);
      }
      if (!validationResult.specialChar) {
        result.push(` at least 1 Special Character`);
      }
      if (result.length === 1) {
        return { password: `Require ${result[0]}.` };
      } else {
        let text = `Require`;
        result.forEach((item, i) => {
          if (i === 0) {
            text += `${item}`;
          } else if (result.length === i + 1) {
            text += ` and ${item}`;
          } else {
            text += `, ${item}`;
          }
        });
        return { password: text };
      }
    }
  }
  static confirmPassword(passwordField: string) {
    return (control: AbstractControl) => {
      const value = control.value;
      if (!value) {
        return null;
      }
      if (control.parent.controls[passwordField].value === value) {
        return null;
      }
      return { confirmPassword: true };
    };
  }

  static misMatchPasswords(passwordField: string, confirmPasswordField: string) {
    return (control: AbstractControl) => {
      const password = control.get(passwordField).value;
      const confirmPassword = control.get(confirmPasswordField).value;
      if (!password || !confirmPassword) {
        return null;
      }
      if (password === confirmPassword) {
        return null;
      }
      return { misMatchPasswords: true };
    };
  }
  static requireAnyOf(...fields) {
    return (control: AbstractControl) => {
      const fieldValues = fields.map((field) => control.get(field).value);
      const isAllFieldsEmpty = fieldValues.every((val) => isEmptyPerType(val));
      return isAllFieldsEmpty ? { requireAnyOf: true } : null;

      function isEmptyPerType(value) {
        if (value === null) {
          return true;
        }
        switch (typeof value) {
          case 'object':
            if (value.length !== undefined) {
              // value is an array
              return value.length === 0;
            } else {
              return !value;
            }
          default:
            return !value;
        }
      }
    };
  }

  static requireIf(field: string, fn: Function) {
    let changesSubscription;
    return (control: AbstractControl) => {
      const value = control.value;
      if (!changesSubscription && control.parent) {
        changesSubscription = control.parent.get(field).valueChanges.subscribe((val) => {
          control.setValue(control.value);
        });
      }
      if (fn && control.parent && fn(control.parent.get(field))) {
        if (isEmptyOrWhiteSpaces(value)) {
          return { requireIfTrue: true };
        }
      }
      return null;
    };
  }

  static requireIfTrue(field: string) {
    return (control: AbstractControl) => {
      const value = control.value;
      // console.log(field, control.parent && control.parent.get(field).value);
      // console.log(control.parent && !!control.parent.get(field).value);
      if (control.parent && !!control.parent.get(field).value) {
        if (isEmptyOrWhiteSpaces(value)) {
          return { requireIfTrue: true };
        }
      }
      return null;
    };
  }
  static requireIfAttemptsExceed(status: boolean) {
    return (control: AbstractControl) => {
      const value = control.value;
      if (status) {
        if (isEmptyOrWhiteSpaces(value)) {
          return { required: true };
        }
      }
      return null;
    };
  }
  static ifValueGreaterThan(field: string) {
    let changesSubscription;
    return (control: AbstractControl) => {
      const value = control.value;
      if ((!!value || value === 0) && control.parent) {
        if (Number(control.parent.get(field).value) <= value) {
          return { greaterThan: true };
        }
      }
      if (control.parent && !control.parent.get(field).value) {
        if (!changesSubscription) {
          changesSubscription = control.parent.get(field).valueChanges.subscribe((val) => {
            if (Number(control.parent.get(field).value) <= value) {
              return { greaterThan: true };
            } else {
              return null;
            }
          });
        }
      }
      return null;
    };
  }
  static requireIfFalse(field: string) {
    let changesSubscription;
    return (control: AbstractControl) => {
      const value = control.value;
      if (control.parent && !control.parent.get(field).value) {
        if (!changesSubscription) {
          changesSubscription = control.parent.get(field).valueChanges.subscribe((val) => {
            control.setValue(control.value);
          });
        }
        if (isEmptyOrWhiteSpaces(value)) {
          return { requireIfTrue: true };
        }
      }
      return null;
    };
  }
  static requireIfNews(field: string) {
    let changesSubscription;
    return (control: AbstractControl) => {
      const value = control.value;
      if (control.parent) {
        if (control.parent.get(field).value) {
          if (isEmptyOrWhiteSpaces(value)) {
            return { requireIfNews: true };
          }
        }
        if (!changesSubscription) {
          changesSubscription = control.parent.get(field).valueChanges.subscribe((val) => {
            control.setValue(control.value);
          });
        }
      }
      return null;
    };
  }

  static validCharsFor(type: string) {
    return (control: AbstractControl) => {
      const value = control.value;
      if (!value) {
        return null;
      }
      switch (type) {
        case 'initials':
          if (/[^a-z_ -.]/i.test(value.trim())) {
            return { validCharsFor: true };
          }
          break;
        case 'name':
          if (/^[ \t]+|[ \t][^a-z0-9_ -]/i.test(value)) {
            return { validCharsFor: true };
          }
          break;
        case 'userName':
          if (/[^a-zA-Z]/i.test(value)) {
            return { validCharsFor: true };
          }
          break;
      }
      return null;
    };
  }

  static pattern(regex, countryField?) {
    // mobilePhoneCountryCode
    return (control: AbstractControl) => {
      let value = control.value;
      if (isEmptyOrWhiteSpaces(value)) {
        return null;
      }
      if (typeof value === 'string') {
        value = value.trim();
      }
      let countryCode =
        (countryField && control.parent && control.parent.controls[countryField] && control.parent.controls[countryField].value) || '94';
      if (countryCode === '94') {
        if (regex.test(value)) {
          return null;
        }
        return { pattern: true };
      } else if (countryCode === '880') {
        if (regex.test(value)) {
          return null;
        }
        return { pattern: true };
      } else {
        return null;
      }
    };
  }

  static notNone(prop = 'id', matchVal: any = 0) {
    return (control: AbstractControl) => {
      const value = control.value;
      if (!value) {
        return null;
      }

      if (value[prop] === matchVal) {
        return { notNone: true };
      }
      return null;
    };
  }
  static required = (control: AbstractControl) => {
    let value = control.value;
    if (isEmptyOrWhiteSpaces(value)) {
      return { required: true };
    }
    return null;
  };

  static minNumber = (min) => {
    return (control: AbstractControl) => {
      let value = control.value;
      if (value < min) {
        return { minNumber: true };
      }
      return null;
    };
  };

  static requiredToBeTruthy = (control: AbstractControl) => {
    let value = control.value;
    if (!value) {
      return { requiredToBeTruthy: true };
    }
    return null;
  };

  static areaCode = (control: AbstractControl) => {
    let value = control.value;
    if (!!value) {
      value = value.trim();
    }
    if (!!value && !AREACODE_REGEXP.test(value)) {
      return { areaCode: true };
    }
    return null;
  };
  static omitSpecialCharators = (control: AbstractControl) => {
    let value = control.value;
    if (!!value) {
      value = value.trim();
    }
    if (!!value && !OMIT_SPECIALCHARACTORS_REGEXP.test(value)) {
      return { omitSpecialCharators: true };
    }
    return null;
  };
  static nameOnlyWithDots = (control: AbstractControl) => {
    let value = control.value;
    if (!!value) {
      value = value.trim();
    }
    if (!!value && !NAME_ONLY_WITH_DOTS_REGEXP.test(value)) {
      return { nameOnlyWithDots: true };
    }
    return null;
  };

  static digitsOnly = (control: AbstractControl) => {
    let value = control.value;
    if (!!value) {
      value = value.trim();
    }
    if (!!value && !DIGITSONLY_REGEXP.test(value)) {
      return { digitsOnly: true };
    }
    return null;
  };

  static nic = (control: AbstractControl) => {
    let value = control.value;
    if (!!value) {
      value = value.trim();
    }
    if (!!value && !NIC_REGEXP.test(value)) {
      return { nic: true };
    }
    return null;
  };

  static nicBn = (control: AbstractControl) => {
    let value = control.value;
    if (!!value) {
      value = value.trim();
    }
    if (!!value && !NIC_REGEXP_BN.test(value)) {
      return { nic: true };
    }
    return null;
  };

  static passport = (control: AbstractControl) => {
    let value = control.value;
    if (!!value) {
      value = value.trim();
    }
    if (!!value && (value.length > 12 || !PASSPORT_REGEXP.test(value))) {
      return { passport: true };
    }
    return null;
  };
  static dateRequired = (control: AbstractControl) => {
    const value = control.value;
    if (!value) {
      return { dateRequired: true };
    }
    return null;
  };
  static stockcode = (control: AbstractControl) => {
    let value = control.value;
    if (isEmptyOrWhiteSpaces(value)) {
      return { required: true };
    }
    if (!!value) {
      value = value.trim();
    }
    if (!!value && !STOCKCODE_REGEXP.test(value)) {
      return { stockcode: true };
    }
    return null;
  };
  static currency = (control: AbstractControl) => {
    let value = control.value;

    if (!!value && !CURRENCY_REGEXP.test(value)) {
      return { currency: true };
    }
    return null;
  };

  static maxLength(textLng: number) {
    return (control: AbstractControl) => {
      let value = control.value;
      if (!!value) {
        value = value.toString();
        value = value.trim();
      }

      if (!!value && value.length > textLng) {
        const trimValue = value.slice(0, textLng);
        control.setValue(trimValue);
        if (value.length > textLng + 1) {
          return { maxLength: true };
        }
      }

      return null;
    };
  }
  static numberLengthEqualTo(textLng: number) {
    return (control: AbstractControl) => {
      let value = control.value;
      if (!!value) {
        value = value.toString();
        value = value.trim();
      }
      if (!!value && (value.length < textLng || value.length > textLng)) {
        return { numberLengthEqualTo: true };
      }

      return null;
    };
  }
  static ReEnableValidator(status) {
    return (control: AbstractControl) => {
      if (status) {
        if (control.pristine) {
          return { ReEnableValidator: true };
        }
        return null;
      }
    };
  }
  static ReEnableMobileValidator(status) {
    let changesSubscription;
    let valueEdited = false;
    return (control: AbstractControl) => {
      if (status) {
        if (!changesSubscription && control.valueChanges) {
          changesSubscription = control.valueChanges.subscribe((val) => {
            valueEdited = true;
          });
        }
        if (!valueEdited) {
          return { ReEnableValidator: true };
        } else {
          return null;
        }
      }
    };
  }
}

function isEmptyOrWhiteSpaces(value) {
  if (value === 0) {
    return false;
  }
  if (value && value.length === 0) {
    return true;
  }
  if (!value) {
    return true;
  }
  if (value.trim && !value.trim()) {
    return true;
  }
  return false;
}
